import React, { useCallback, useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { sanitizeInput, showToast } from "../../../../utils/utils";
import { showToastType } from "../../../../utils/constants/appConstants";
import { apiKey } from "../../../../utils/appConfig";
import PropTypes from "prop-types";
import privateAxios from "../../../../utils/axiosPrivate";
import { getReportingUpdateSalesChecklistCommentUrl } from "../../../../utils/constants/apiEndPoints";
import { getEditorConfig } from "../../../../utils/constants/tinyMceConfig";

const CreditDecisionNotes = ({ userId, salesAdditionalNote }) => {
  const [commentData, setCommentData] = useState({ creditNotes: "" });
  const editorRef = useRef(null);
  const originalNotesRef = useRef({ creditNotes: "" });

  const updateSalesData = useCallback(
    async (type, value) => {
      const currentValue = value !== undefined ? value : commentData[type];
      const originalValue = originalNotesRef.current[type] || "";
      if (currentValue === originalValue) return;
      try {
        const response = await privateAxios.post(
          getReportingUpdateSalesChecklistCommentUrl(userId),
          {
            section: "CREDIT_DECISION_NOTES",
            note: sanitizeInput(currentValue)
          }
        );
        showToast(response?.data?.message, showToastType.success);
        originalNotesRef.current[type] = currentValue;
      } catch (error) {
        showToast(error?.message, showToastType.error);
      }
    },
    [commentData, privateAxios, userId]
  );

  const handleEditorChange = (content) => {
    setCommentData((prev) => ({ ...prev, creditNotes: content }));
  };

  useEffect(() => {
    const creditNote = salesAdditionalNote?.find(
      (n) => n.section === "CREDIT_DECISION_NOTES"
    );

    if (creditNote) {
      const noteContent = creditNote.note || "";

      // Only update if value changed to avoid unnecessary re-renders
      setCommentData((prev) => {
        if (prev.creditNotes !== noteContent) {
          return { creditNotes: noteContent };
        }
        return prev;
      });

      // Update the original notes reference
      originalNotesRef.current = { creditNotes: noteContent };
    }
  }, [salesAdditionalNote]);

  return (
    <div>
      <Editor
        apiKey={apiKey}
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={commentData.creditNotes}
        onEditorChange={handleEditorChange}
        init={getEditorConfig((content) => {
          setCommentData((prev) => ({ ...prev, creditNotes: content }));
          updateSalesData("creditNotes", content);
        })}
      />
    </div>
  );
};

CreditDecisionNotes.propTypes = {
  userId: PropTypes.any.isRequired,
  salesAdditionalNote: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string,
      note: PropTypes.string
    })
  )
};

export default CreditDecisionNotes;
